export enum RefundStatus {
  CREATED = 'created',
  PENDING = 'pending',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted',
  FAILED = 'failed',
  PROCESSING = 'processing',
  CANCELED = 'canceled',
}
